import { render } from "./BlViewVoice.vue?vue&type=template&id=59f97596&scoped=true"
import script from "./BlViewVoice.vue?vue&type=script&lang=js"
export * from "./BlViewVoice.vue?vue&type=script&lang=js"

import "./BlViewVoice.vue?vue&type=style&index=0&id=59f97596&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f97596"]])

export default __exports__